import { useNavigate } from 'react-router-dom';
import Button from '../../components/form-control/Button';
import useUserAccount from '../../hooks/stateHooks/userAccountHook';
import { SIGN_IN } from '../../resources/links';

function NotFound() {
  const navigate = useNavigate();
  const { IS_AUTHENTICATED } = useUserAccount();

  return (
    <div className="w-full h-full flex items-center justify-center  flex-col bg-white">
      <div className="mb-[41px]">
        <img src="/img/404 Page Illustration.svg" alt="" />
      </div>
      <div className="mb-7">
        <h1 className=" font-[Gilroy-Bold] text-[48px] leading-[56px]">Not found</h1>
      </div>
      <div className="">
        <span className="font-[Gilroy-Medium] text-[16px] leading-[19px]">
          We couldn&apos;t find what you were looking for.
        </span>
      </div>
      <div className="w-full flex flex-col justify-center items-center">
        <span className="font-[Gilroy-Medium] text-[16px] leading-[19px] w-full text-center">
          Try again.
        </span>
        <Button
          label={IS_AUTHENTICATED ? "Back to dashboard" : 'Log in'}
          className='bg-primary-main px-6 rounded text-white mt-4'
          onClick={() => {
            navigate(`/auth/${SIGN_IN}`, { replace: true })
          }}
        />
      </div>
    </div>
  );
}

export default NotFound;
